import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PromotePlanComponent } from './promote-plan.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [PromotePlanComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [PromotePlanComponent]
})
export class PromotePlanModule { }

